<!--
 * @description: 
 * @param: 
 * @return: 
-->
<template>
<!-- <el-config-provider :locale="locale">  -->
	<div class="app-container">
		<router-view v-slot="{ Component }">
			<transition name="el-zoom-in-center">
				<component :is="Component"></component>
			</transition>
		</router-view>
		<loading class="loading"></loading>
	</div>
<!-- </el-config-provider> -->
</template>

<script>
import loading from "@/components/loading.vue"
import {ElConfigProvider} from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default {
	name: 'app',
	components: {
		loading,
		[ElConfigProvider.name]:ElConfigProvider,//添加组件
	},
	data() {
		return {
			locale: zhCn
		}
	},
	created() {
		if (sessionStorage.getItem('type') != null) {
			window.document.documentElement.setAttribute("data-theme", sessionStorage.getItem('type'))
		} else {
			window.document.documentElement.setAttribute("data-theme", 'base')
		}

		if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
			// alert('Safari可能会导致样式问题，请您更换Chrome')
		}
	}
}
</script>

<style lang="scss">
@import "~@/assets/styles/initHtmlSet.scss";
@import "~@/assets/styles/_handle.scss";

.app-container {
	width: 100%;
	height: 100%;
	position: relative;

	.loading {
		position: absolute;
	}
}

</style>
